import styles from '../select.module.css';

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SelectOption = ({ option, isSelected, onClick, titleKey, multiple, renderOption }) => {
  if (renderOption) {
    return (
      <div onClick={onClick} className={styles.optionWrapper}>
        {renderOption({ option, isSelected })}
      </div>
    );
  }

  return (
    <div className={classNames(styles.option, { [styles.selected]: isSelected })} onClick={onClick}>
      {option[titleKey]}
    </div>
  );
};

SelectOption.propTypes = {
  option: PropTypes.object.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  titleKey: PropTypes.string.isRequired,
  multiple: PropTypes.bool.isRequired,
  renderOption: PropTypes.func,
};

export default SelectOption;
